export enum SlotType {
  FIXED = 'FIXED',
  VARIANT = 'VARIANT',
  POOL = 'POOL',
}
export enum BundleType {
  FIXED = 'FIXED',
  VARIABLE = 'VARIABLE',
}

export enum Operation {
  ADD = 'add',
  MINUS = 'minus',
}
